import React, { useEffect } from "react";
import { useContent } from "../hooks/useContent";
import { useTranslation } from "react-i18next";

import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
const CeoWord = () => {
  const { word, fetchWord } = useContent();
  const { i18n } = useTranslation()
  
  useEffect(() => {
    fetchWord();
  }, [i18n.language]);

  const coloredLine = (
    <div className="h-3 w-10 bg-purple inline-block mx-2"></div>
  );

  return (
    <>
    <Header pagetitle={"About arcelia"} subtitle={"CEO word"}/>
    <div style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
      <div className="relative m-3 flex flex-col gap-3 md:block md:w-96 md:mt-40 mx-auto">
        <img
          className="nd:w-96 rounded-2xl md:z-20 relative"
          src={word.word_image_1 ?? require("../assets/p1.jpg")}
          alt=""
        />
        <img
          className="md:w-96 rounded-2xl  md:absolute relative md:bottom-20 md:right-72 md:z-30"
          src={word.word_image_2 ?? require("../assets/p2.jpg")}
          alt=""
        />
        <img
          className="md:w-96 rounded-2xl  md:absolute relative md:bottom-20 md:left-72 md:z-10"
          src={word.word_image_3 ?? require("../assets/p3.jpg")}
          alt=""
        />
      </div>
      <div className="word flex flex-col gap-5 px-2 md:px-40 py-8">
        <h1 className="font-semibold text-4xl pb-5 text-black">
          {/* كلمة رئيس مجلس الإدارة */}
          {word.word_title_0}
        </h1>
        <p>
          {/* اهتمت رؤية المملكة العربية السعودية 2030 بقطاع الأعمال؛ حيث كان من
                    محاورها الرئيسية؛ تبني اقتصادًا مزدهرًا ينعم فيه الجميع بفرص متعددة
                    للنجاح، عبر توفير بيئة عمل داعمة للشركات الصغيرة والمتوسطة والكبيرة،
                    والاستثمار في التعليم استعدادًا لوظائف المستقبل، لتوفير مستقبلٍ زاخر
                    للجميع على أرض المملكة. */}
          {word.word_content_0}
        </p>
        <p>
          {/* ومن هذا المنطلق يطيبُ لي أن أقدم بفخرٍ واعتزاز شركة “أرسيليا”؛ وهي
                    شركة سعودية تأسست عام 0000؛ وهي من المجموعات الاستثمارية الرائدة التي
                    تركز على رؤية المستقبل؛ وتنشط في قطاع الأعمال بالمملكة العربية
                    السعودية؛ تتكون مجموعة “أرسيليا” من عدة شركات ذات أنشطة متعددة؛ وتنضوي
                    تحتها مجموعة شركات وأسماء أعمال مختلفة في أنشطتها. */}
          {word.word_content_0_1}
        </p>
      </div>
      <div className="plans flex flex-col md:flex-row gap-10 px-2 md:px-40 py-8">
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-5">
            <h1 className="text-md font-medium">
              {coloredLine}
              {/* شركات “أرسيليا” العقاري */}
              {word.word_title_1}
            </h1>
            <h1 className="font-semibold text-xl pb-5 text-black">
              {/* مجموعة متنوعة من الخدمات */}
              {word.word_content_1}
            </h1>
            <p>
              {/* تتخصص شركات “أرسيليا” في طيف واسع ومجموعة متنوعة من الخدمات؛ من
                            أهمها خدمات التقييم العقاري والتسويق العقاري؛ وتنظيم الفعاليات؛
                            وإنتاج وتوزيع المواد الغذائية؛ وتتوحد كل الشركات الفرعية وتتكاتف
                            جهودها تحت “مظلة” الشركة الأم “أرسيليا”. */}
              {word.word_content_1}
            </p>
          </div>
          <div className="flex flex-col gap-5">
            <h1 className="text-md font-medium">
              {coloredLine}
              {/* شركات “أرسيليا” العقاري */}
              {word.word_title_2}
            </h1>
            <h1 className="font-semibold text-xl pb-5 text-black">
              {/* التزامنا بِقيَمنا */}
              {word.word_content_2}
            </h1>
            <p>
              {/* من خلال التزامنا بِقيَمنا نحقق أهدافنا ونظهر ثقافتنا مما يعود
                            بالنفع على الشركاء والمتعاملين معنا، ونطمح دوماً لأن نوفرَ بيئة
                            عمل جاذبة للكفاءات ونأمل أن نحققَ الشراكة مع موظفينا؛ ولم تغفل
                            الشركة مسؤولياتِها الاجتماعية ممثلة في نسبة التوطين حيث تحمل
                            الشركة تصنيفًا عاليًا للسعودة؛ وتقدم رواتب وحوافز مجزية للسعوديين
                            من خريجي الجامعات ومعاهد الدبلوم العالي. */}
              {word.word_content_2_1}
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-5">
            <h1 className="text-md font-medium">
              {coloredLine}
              {/* شركات “أرسيليا” العقاري */}
              {word.word_title_3}
            </h1>
            <h1 className="font-semibold text-xl pb-5 text-black">
              {/* إدارة ذاتية منفصلة */}
              {word.word_content_3}
            </h1>
            <p>
              {/* وتتمتع كل شركة أو اسم عمل بإدارة ذاتية منفصلة؛ تتكون من مدير عام
                            متخصص في المجال ومجموعة مساعدة من الموظفين؛ وتملك كل شركة أو اسم
                            عمل حساب مصرفي منفصل ورأس مال منفصل مخصص للنشاط؛ وبرامج محاسبية
                            وسياسة تسويقية منفصلة. */}
              {word.word_content_3_1}
            </p>
          </div>
          <div className="flex flex-col gap-5">
            <h1 className="text-md font-medium">
              {coloredLine}
              {/* شركات “أرسيليا” العقاري */}
              {word.word_title_4}
            </h1>
            <h1 className="font-semibold text-xl pb-5 text-black">
              {/* احترام وثقة الشركاء والعملاء */}
              {word.word_content_4}
            </h1>
            <p>{word.word_content_4_1}</p>
          </div>
        </div>
      </div>
      <div className="px-2 md:px-40 py-8 pb-20">
        <h1 className="font-semibold text-xl pb-5 text-black">
          {coloredLine}
          {word.word_title_5}
        </h1>
        <h1 className="text-md font-medium">{word.word_content_5}</h1>
        <br />
        <p>{word.word_content_5_1}</p>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default CeoWord;
